module.exports = __webpack_public_path__ + "static/media/small-arrow-white.13d629cc.svg";